import { Tooltip } from '@billy/design-system'
import React, { ReactElement } from 'react'

import * as Styled from './styles'
import { Variant } from './types/variant'

export type StatusFormatterVariant = Variant

interface StatusFormatterProps {
  title?: string
  variant?: StatusFormatterVariant | [StatusFormatterVariant, StatusFormatterVariant]
}

export const StatusFormatter = ({ variant = 'primary', title, ...rest }: StatusFormatterProps): ReactElement => {
  const statusDot = (
    <Styled.StatusFormatterWrapper aria-label={title} role={title ? 'img' : undefined} {...rest} variant={variant} />
  )

  return title ? (
    <Tooltip label={title} placement="top">
      {statusDot}
    </Tooltip>
  ) : (
    statusDot
  )
}
